// extracted by mini-css-extract-plugin
module.exports = {"up":"Caret_up__RdK_L","down":"Caret_down__cac2C","right":"Caret_right__ZUhXe","animate":"Caret_animate__B80Z2"};